import React, {createRef, RefObject} from 'react'
import {findDOMNode} from "react-dom"

import VScroll from "../../core/gd-components/scrolling/custom-v-scroll/v-scroll"
import {LayoutMenuState} from "../layout/const"
import MainMenu_PopoverMenuV2 from "./menu-popover/main-menu-popover-v2"
import MainMenu_Static from "./menu-static/main-menu-static"
import {NavigationSectionType, ScrollToInMenu} from "../../core/model2/navigation/@const"
import {EVENT_BUS_MENU_RERENDER} from "./sections/const"
import {BUS_SHOW_IN_MENU} from "./@events"
import {BUS_MAIN_MENU_OUTSIDE_CLICK} from "../navigation/@const";

// const debug = "UIMainMenuContainer"
const debug = false

type State = {
    // section     : string,
    reRender    : boolean
    noAnimation : boolean
}

type Props = {
}

export default class UIMainMenuContainer extends React.Component<Props, State> {

    uid: any

    public popoverRef           : RefObject<any> = createRef()
    public popoverRefMainScroll : React.RefObject<VScroll> = React.createRef<VScroll>()
    public popoverRefMenu       : React.RefObject<any> = React.createRef<any>()
    public popoverRefScroll     : React.RefObject<VScroll> = React.createRef<VScroll>()

    public refMenu              : React.RefObject<any> = React.createRef<any>()
    public refScroll            : React.RefObject<VScroll> = React.createRef<VScroll>()

    private _popoverMenuNode    : any = undefined

    constructor(props: Props) {
        super(props)

        this.uid = gd.utils.guid()

        gd.layout.mainMenuStatic  = this

        this.state = {
            reRender    : false,
            noAnimation : false
        }
    }

    componentDidMount() {
        gd.bus.subscribe(BUS_SHOW_IN_MENU, this, this.onShowInMenu)
        gd.bus.subscribe('menu:vertical-separator-resize-left',this, this.onResizeMenu)
        gd.bus.subscribe(EVENT_BUS_MENU_RERENDER,this, this.reRender)

        gd.router.on('route', this.onRouteChanged)
    }

    componentWillUnmount() {
        // gd.layout.mainMenuStatic  = null // Eto lomaet navigation pri smene Skins

        gd.router.off('route', this.onRouteChanged)

        gd.bus.unsubscribe(this)
    }

    onRouteChanged = () => {
        if (gd.layout.menuState === LayoutMenuState.STATIC) return

        this.hide()
    }

    public show() {
        debug && console.log(debug,"show()")
        gd.layout.isMenuPopoverShown = true

        if (this.popoverMenuNode) {
            this.popoverMenuNode.style.display = 'block'

            // Reset Popover theme. This doesn't work through React. Because DOM is rudely changed.
            this.popoverMenuNode.classList.remove('theme-white')
            this.popoverMenuNode.classList.remove('theme-gray')
            this.popoverMenuNode.classList.remove('theme-dark')
            this.popoverMenuNode.classList.remove('ui-left-theme-asana')
            this.popoverMenuNode.classList.remove('pale-bg')
            this.popoverMenuNode.classList.remove('green')
            this.popoverMenuNode.classList.remove('violet')
            this.popoverMenuNode.classList.remove('turquoise')
            this.popoverMenuNode.classList.add(...gd.ui.uiLeftMenuThemeClass.split(" "))
        } else {
            // posible when my task in main and my work is piined ... we had a bug
            console.log("#034984874 no popoverMenuNode")
        }

        // Important trigger for update new navbar UI
        gd.bus.triggerEvent(BUS_MAIN_MENU_OUTSIDE_CLICK)

        this.popoverRefMainScroll.current?.calculateScroll()
        this.popoverRefScroll.current?.calculateScroll()
        // this.refScroll.current?.calculateScroll()
    }

    public hide() {
        debug && console.log(debug,"hide()")
        gd.layout.isMenuPopoverShown = false

        // Important trigger for update new navbar UI
        gd.bus.triggerEvent(BUS_MAIN_MENU_OUTSIDE_CLICK)

        if (!this.popoverMenuNode) {
            console.warn("#83284723 how come ?")
            return
        }

        this.popoverMenuNode.style.display = 'none'
    }

    get popoverMenuNode() {
        if (this._popoverMenuNode) return this._popoverMenuNode

        let popoverMenuClass = gd.ui.uiLeftPopoverClassName

        return document.getElementsByClassName(popoverMenuClass)[0]
    }

    get isVisible() {
        return this.popoverMenuNode?.style?.display !== 'none'
    }

    onResizeMenu = () => {
        gd.layout.calculateWidth()
        this.forceUpdate()
    }

    onShowInMenu = async (scrollTo: ScrollToInMenu = {}) => {
        debug && console.log(debug, "onShowInMenu", this.uid, scrollTo, this.popoverRef, this.refMenu, this.refScroll)

        let pinId
        if (scrollTo.projectId)                             pinId = 'projectId-'+scrollTo.projectId
        if (scrollTo.taskId)                                pinId = 'taskId-'+scrollTo.taskId
        if (scrollTo.customViewId)                          pinId = 'viewId-'+scrollTo.customViewId
        if (scrollTo.userId && scrollTo.organizationId)     pinId = 'userId-{0}-{1}'.f(scrollTo.organizationId, scrollTo.userId)
        if (scrollTo.portfolioId)                           pinId = 'portfolioId-'+scrollTo.portfolioId

        switch (gd.layout.navigation.state.currentSection?.id) {
            case NavigationSectionType.PROJECTS:
                if (scrollTo.projectId && this.menu.expandParentsForProject) {
                    await this.menu.expandParentsForProject(scrollTo.projectId) // wait for project node to become visible
                }
                break;
        }

        // @ts-ignore
        const node = findDOMNode(this.self)?.getElementsByClassName(pinId)[0] // find node to scroll to
        debug && console.log(debug, "onShowInMenu node", node?.offsetTop, node)
        if (node) this.scroll.setScrollTop(node.offsetTop, true)
    }

    get self(): any {
        return this.popoverRef.current ? this.popoverRef.current : this
    }

    get menu(): any {
        return this.popoverRefMenu.current ? this.popoverRefMenu.current : this.refMenu.current
    }

    get scroll():any {
        return this.popoverRefScroll.current ? this.popoverRefScroll.current : this.refScroll.current
    }

    onClickOutside = (mouseEvent:MouseEvent) => {
        debug && console.log(debug, "onClickOutside", mouseEvent.target)

        if (gd.utils.Dom.findNodeByClassName(mouseEvent.target,
            [
                'ui-navigation',
                'ui-navigation-teams',
                'ui-navigation-click-up',
                'ui-menu-add-view-popover',
                'navigation-more',
                'show-in-menu-button'
            ])
        ) {
            return
        }

        this.hide()
    }

    reRender = async (noAnimation: boolean = false) => {
        // the current navigation section may have no menu - for now we just ignore this change the
        if (!gd.layout.navigation.state.currentSection?.menuComponent) {
            debug && console.orange(debug, "No menu component. Do nothing please...")
            return true
        }

        this.setState({
            reRender    : true,
            noAnimation
        })
    }

    render() {
        if (!gd.layout.navigation.state.currentSection) return null

        debug && console.log(debug, "render() gd.layout.isMenuHiddenForCurrentApp=", gd.layout.isMenuHiddenForCurrentApp)

        if (gd.layout.isMenuHiddenForCurrentApp || gd.layout.menuState !== LayoutMenuState.STATIC) {
            return <MainMenu_PopoverMenuV2 popoverRef       = {this.popoverRef}
                                           refMainScroll    = {this.popoverRefMainScroll}
                                           refMenu          = {this.popoverRefMenu}
                                           refScroll        = {this.popoverRefScroll}
                                           menu             = {this}/>
        } else {
            return <MainMenu_Static refMenu        = {this.refMenu}
                                    refScroll      = {this.refScroll}
                                    noAnimation    = {this.state.noAnimation}/>
        }
    }
}
